import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { classNames, Flex, FlexColumn, NumberDisplay, SkeletonLine, TextBody, TextDisplay } from "@opensea/ui-kit";
import { ViewWalletPortfolioValueFragment } from "./ViewWalletPortfolioValue.fragment";
export function ViewWalletPortfolioValue(t0) {
  const $ = _c(13);
  const {
    portfolioValue: portfolioValueKey,
    className
  } = t0;
  let t1;
  if ($[0] !== portfolioValueKey) {
    t1 = readFragment(ViewWalletPortfolioValueFragment, portfolioValueKey);
    $[0] = portfolioValueKey;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const portfolioValue = t1;
  let t2;
  if ($[2] !== className) {
    t2 = classNames("gap-1 px-0", className);
    $[2] = className;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== portfolioValue.native.symbol || $[5] !== portfolioValue.native.unit) {
    t3 = <TextDisplay size="sm"><NumberDisplay suffix={portfolioValue.native.symbol} value={portfolioValue.native.unit} /></TextDisplay>;
    $[4] = portfolioValue.native.symbol;
    $[5] = portfolioValue.native.unit;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== portfolioValue.usd) {
    t4 = <TextBody color="text-secondary" size="sm"><NumberDisplay display="usd" value={portfolioValue.usd} /></TextBody>;
    $[7] = portfolioValue.usd;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
    t5 = <FlexColumn className={t2}>{t3}{t4}</FlexColumn>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}
export function ViewWalletPortfolioValueSkeleton() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <TextDisplay size="sm"><SkeletonLine className="h-8 w-[8ch]" /></TextDisplay>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <FlexColumn className="gap-1 px-0">{t0}<Flex className="h-4 items-center"><SkeletonLine className="h-[14px] w-[90px]" /></Flex></FlexColumn>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}